import "./publications.css"
import React from 'react';
import policyBriefs from "./policy_briefs.json";

// Inline CSS for hover effects and larger thumbnails
const styles = `
.policy-brief-row {
    transition: background 0.15s;
    margin-bottom: 12px;
    padding-bottom: 0px;
}

.policy-type-bubble {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background: #f5f5dc;
    color: #8b4513;
    border-radius: 16px;
    padding: 6px 16px;
    font-size: 0.8rem;
    font-weight: 700;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    line-height: 1;
    width: fit-content;
    z-index: 10;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    white-space: nowrap;
    border: 1px solid #e6e6cc;
}

.bubble-and-image-container {
    position: relative;
    padding-top: 20px;
    margin-top: 12px;
    overflow: visible;
}

.policy-brief-image-container {
    position: relative;
    overflow: visible;
}
.policy-brief-row:hover .policy-brief-title {
    position: relative;
}
.policy-brief-title {
    display: inline-block;
    position: relative;
    cursor: pointer;
}
.policy-brief-title::after {
    content: '';
    display: block;
    position: absolute;
    left: 0; bottom: -2px;
    width: 0;
    height: 2px;
    background: var(--hai-gold, #e6c068);
    transition: width 0.3s cubic-bezier(.4,0,.2,1);
}
.policy-brief-row:hover .policy-brief-title::after {
    width: 100%;
}
.policy-brief-image-container {
    overflow: hidden;
    /* Make the image container a bit smaller and tighter */
    width: 130px;
    height: 170px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 16px;
}
.policy-brief-image {
    transition: transform 0.3s cubic-bezier(.4,0,.2,1);
    width: 120px;
    height: 160px;
    object-fit: contain; /* Show full image, not cropped */
    border-radius: 6px;
    box-shadow: var(--shadow-card, 0 2px 8px rgba(0,0,0,0.08));
    background: #fff;
}
.policy-brief-row:hover .policy-brief-image {
    transform: scale(1.07);
}
.policy-brief-content.hai-row {
    gap: 18px;
    align-items: flex-start;
    padding: 6px 0 0 0;
}
.policy-brief-text.hai-text {
    margin-right: 0;
    padding: 0;
}
.policy-brief-divider {
    margin: 0px 0 0 0;
    border-bottom: 1px solid #222;
    opacity: 0.5;
}
`;

function getImageSrc(image) {
    // Remove leading /public if present, since public/ is the web root
    if (image && image.startsWith('/public/')) {
        return image.replace('/public', '');
    }
    return image;
}

export default function PolicyBriefs() {
    // Sort briefs by date, most recent first
    const sortedBriefs = [...policyBriefs].sort((a, b) => new Date(b.date) - new Date(a.date));
    return (
        <div className="policy-briefs-page hai-style">
            <style>{styles}</style>
            <div className="policy-briefs-header">
                <h1>Policy Publications</h1>
            </div>
            <div className="policy-briefs-list hai-list">
                {sortedBriefs.map((brief, idx) => (
                    <div className="policy-brief-row" key={idx}>
                        <div className="policy-brief-content hai-row">
                            <div className="policy-brief-text hai-text">
                                <h2 className="policy-brief-title">
                                    <a href={brief.brief_link} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>
                                        {brief.title}
                                    </a>
                                </h2>
                                <div className="policy-brief-authors">{brief.authors.join(', ')}</div>
                                <div className="policy-brief-date">{new Date(brief.date).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}</div>
                                <div className="policy-brief-summary">{brief.summary}</div>
                            </div>
                            {brief.image && (
                                <div className="bubble-and-image-container">
                                    <div className="policy-type-bubble">{brief.type}</div>
                                <div className="policy-brief-image-container hai-image-container">
                                    <img className="policy-brief-image hai-image" src={getImageSrc(brief.image)} alt={brief.title} />
                                </div>
                                </div>
                            )}
                        </div>
                        {idx !== sortedBriefs.length - 1 && <div className="policy-brief-divider" />}
                    </div>
                ))}
            </div>
        </div>
    );
} 